export const CONSENTIMENTO_COOKIES = "escavador.cookies.consentimento";
export const SAFE_INIT_COOKIE = "escavador.cookies.app";

export const CONFIGURACOES_CCONSENTMANAGER = {
  categories: [
    {
      name: "Cookies Necessários",
      description:
        "São cookies necessários para a operacionalização regular de determinadas funcionalidades do website como, por exemplo, restauração de sessões do chat na navegação entre páginas e/ou quando o usuário retorna ao website alguns dias depois. Como são necessários à regular operação dos serviços do website, não podem ser desativados.",
      services: [
        {
          mandatory: true,
          checked: true,
          wanted: true,
          name: "Escavador",
        },
        {
          mandatory: true,
          checked: true,
          wanted: true,
          name: "Zendesk",
        },
        {
          mandatory: true,
          checked: true,
          wanted: true,
          name: "Cloudflare",
        },
      ],
      mandatory: true,
    },
    {
      name: "Cookies Analíticos",
      description:
        "São cookies de terceiros que informam, entre outros dados, a duração da sessão, as páginas visitadas, e dados sobre a navegação no website, com a finalidade de aperfeiçoar a experiência dos visitantes. Referidos dados são disponibilizados ao Escavador anonimizados, agregados, por meio de plataformas parceiras, onde ficam armazenados.",
      services: [
        {
          mandatory: false,
          checked: false,
          wanted: false,
          name: "Google Analytics",
          search: "analytics",
          cookieName: ["_gid", /^_ga/, "1P_JAR"],
        },
      ],
    },
    {
      name: "Cookies de Marketing",
      description:
        "São cookies de terceiros utilizados para exibição de publicidade direcionada no website do Escavador com base em dados de navegação dos visitantes do website, bem como cookies para retargeting do website do Escavador em páginas de terceiros.",
      services: [
        {
          mandatory: false,
          checked: false,
          wanted: false,
          name: "Google Adsense",
          search: "google_adsense",
          cookieName: "__gads",
        },
        {
          mandatory: false,
          checked: false,
          wanted: false,
          name: "Google Ads",
          search: "google_ads",
          cookieName: ["IDE", "ANID"],
        },
        {
          mandatory: false,
          checked: false,
          wanted: false,
          name: "Facebook Pixel",
          search: "facebook_pixel",
          cookieName: "_fbp",
        },
      ],
    },
  ],
};
